(function(){
     'use strict';

     angular
        .module('appback')
        .factory('MicroService', MicroService);

    MicroService.$inject = ['$http'];

    function MicroService($http){

        var service= {
           marcarValidar:marcarValidar,
           getPendienteValidar:getPendienteValidar
        };

        return service;
 		function marcarValidar(validar,pet_id,analitica_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            var data = $.param({
               validar:validar,
               pet_id:pet_id,
               analitica_id:analitica_id
            });
            $http.post('/backend/microbiologia/marcarvalidar', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                return false;
            }
        }

        function getPendienteValidar(pet_id,analitica_id,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;'
                }
            }

            $http.get('/backend/microbiologia/getpendientevalidar', { params : {
               pet_id:pet_id,
               analitica_id:analitica_id
            } }, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

      

      
    }
})();